<template>
	<div class="sub-header" :type="type" :transform="transform">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "SubHeader",
	props: {
		/**
		 * 'default' | 'primary' | 'secondary'
		 */
		type: {
			type: String,
			default: "default",
			validator(value) {
				return ["default", "primary", "secondary"].includes(value);
			}
		},
		/**
		 * 'uppercase' | 'titlecase'
		 */
		transform: {
			type: String,
			default: "uppercase",
			validator(value) {
				return ["uppercase", "titlecase"].includes(value);
			}
		}
	}
});
</script>
<style lang="scss">
@mixin sub-header($type-colors) {
	.sub-header {
		@each $type, $color in $type-colors {
			&[type="#{$type}"] {
				color: $color;
			}
		}
	}
}

.sub-header {
	font-weight: bold;
	font-size: 12px;
	margin-bottom: 12px;

	&[transform="uppercase"] {
		text-transform: uppercase;
	}
	&[transform="titlecase"] {
		text-transform: capitalize;
	}
}

$theme-type-colors: (
	"primary": var(--dashboard-primary),
	"default": var(--dashboard-font-dark),
	"secondary": var(--dashboard-secondary)
);

@include sub-header($theme-type-colors);

$mode-type-colors: (
	"primary": var(--slideout-primary),
	"default": var(--slideout-font-dark),
	"secondary": var(--slideout-secondary)
);
.sideout-container {
	@include sub-header($mode-type-colors);
}
</style>
